exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.log-body .el-input .el-input__inner {\n  height: 38px;\n}\n.log-box .el-tabs__item {\n  font-size: 17px !important;\n}\n.log-box input:-webkit-autofill {\n  box-shadow: 0 0 0 100px #fff inset;\n  -webkit-text-fill-color: #000;\n}\n.log-box .el-button--primary {\n  height: 50px;\n  font-size: 18px;\n  margin-top: 28px;\n}\n.log-box .el-input__inner {\n  height: 50px !important;\n  color: rgba(0, 0, 0, 0.55);\n  padding: 0 40px;\n  font-size: 16px;\n  border: none;\n  background: none;\n  border-bottom: 1px solid #ccc;\n  border-radius: 0;\n}\n.log-box a {\n  color: #FEBB40 !important;\n}\n.log-box .el-checkbox__input.is-checked + .el-checkbox__label {\n  color: #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0a07a4a4","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/root/workspace/platform-admin_Cbe5/src/style/theme.scss","/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/view/login.vue
// module id = 890
// module chunks = 30